import { FaBuilding } from 'react-icons/fa'
import { Sidebar } from 'components/ideal-core-ui'
import { CompanyInfoSection } from 'components/common/CompanyInfoSection'
import s from '../Company.scss'
import { CompanyStatsSection } from './CompanyStatsSection'

const CompanySidebar = ({ company, pipeline, stats }) => {
  return (
    <Sidebar
      className="sidebar-global"
      title={
        <div className={s.sidebarTitle}>
          <FaBuilding />
          At a glance
        </div>
      }
      sidebarType="companySidebar"
      sections={[
        {
          content: (
            <CompanyInfoSection key="0" company={company} companyPipeline={pipeline} companyPage />
          )
        },
        {
          content: <CompanyStatsSection key="1" stats={stats} />,
          condition: !!stats
        }
      ]}
    />
  )
}

export default CompanySidebar
